"use client";

// Shared presentation bits for the admin-user registry detail tabs.
// Split out of AdminUserDetailTabComponents.tsx (module-size).

import React from "react";
import type { User } from "@/lib/types/user";

/** The tab contract: the registry detail modal hands each tab the fetched user. */
export interface AdminUserTabProps {
  item: User;
}

export function Field({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      <span className="text-sm break-words">{children}</span>
    </div>
  );
}
